import React from 'react'
import PageBanner from '../Components/PageBanner'
import ServicesOne from '../Components/Services/ServicesOne'
import ServicesCta from '../Components/Services/ServicesCta'
import BestFeatures from '../Components/Features/BestFeatures'
import Pricing from '../Components/Price/Pricing'
import FaqOne from '../Components/Faq/FaqOne'
import bannerBg from '../assets/img/Banners/CompanyProfilebanner.jpg';
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/home3/block1.png";

const Companyprofile = () => {
  return (
    <>
    <PageBanner title='Company Profile' bannerBg={bannerBg} currentPage='Company Profile' />
    {/* <ServicesOne/>
    <ServicesCta/>
    <BestFeatures/>
    <Pricing/>
    <FaqOne/> */}
    <section className="content-block-wrapper section-padding bg-circle fix pt-0">
        <div className="container">
       
          <div className="row align-items-center section-padding pb-0 pt-5">
            <div className="col-xl-12 col-lg-12 col-12 mt-5 mt-lg-0 order-2 order-lg-1">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About SHREE GITA Group  </h2>
                <div className="checked-features-list style-2">
                
                <div className="row">
                  <div className="col-12">
                    <ul>
                      <li> SHREE GITA Group is a leading name in agro-processing and trading, dedicated to upholding the highest standards in manufacturing. Our commitment to quality has earned us a strong reputation among top-tier clients in India and worldwide. </li>

                      <li>   Established in 1976, SHREE GITA Group is an ISO 9001:2008 & FSSAI-certified company specializing in cotton ginning and pressing, edible oil refining, and oilseed crushing. Our mission is to deliver superior products that align with internationally recognized standards.  </li>

                      <li>Leveraging India's strategic location and abundant resources, we aim to transform these advantages into opportunities that drive our growth. Our vision is to be a premier Indian company, offering top-quality products and exceptional services at highly competitive prices. We prioritize delivering outstanding value to our customers, ensuring they receive the best in quality and cost-effectiveness.</li>

                      <li>  <strong> Our Motto:</strong> The customer is our priority, and we go above and beyond to provide premium products and services to both domestic and international markets.</li>
                      <li> With over a century of industry expertise, we have built a robust and efficient distribution network, enabling us to supply reliable and cost-effective solutions. As a trusted processor of cotton and its byproducts, we continuously test and refine our products to maintain consistent excellence. </li>
                    </ul>
                  </div>
                 
                </div>
              </div> 
                {/* <p>
                SHREE GITA Group is a leading name in agro-processing and trading, dedicated to upholding the highest standards in manufacturing. Our commitment to quality has earned us a strong reputation among top-tier clients in India and worldwide. 
                </p>
                <br></br>
                <p>
                Established in 1976, SHREE GITA Group is an ISO 9001:2008 & FSSAI-certified company specializing in cotton ginning and pressing, edible oil refining, and oilseed crushing. Our mission is to deliver superior products that align with internationally recognized standards. 
                </p>
                <br></br>
                <p>
                Leveraging India's strategic location and abundant resources, we aim to transform these advantages into opportunities that drive our growth. Our vision is to be a premier Indian company, offering top-quality products and exceptional services at highly competitive prices. We prioritize delivering outstanding value to our customers, ensuring they receive the best in quality and cost-effectiveness. 
                </p>
                <br></br>
                <p>
               <strong> Our Motto:</strong> The customer is our priority, and we go above and beyond to provide premium products and services to both domestic and international markets. 
                </p>
                <br></br>
                <p>
                With over a century of industry expertise, we have built a robust and efficient distribution network, enabling us to supply reliable and cost-effective solutions. As a trusted processor of cotton and its byproducts, we continuously test and refine our products to maintain consistent excellence. 
                </p> */}
              </div>
              {/* <div className="checked-features-list style-2">
                <h6>Cotton Varieties We Offer </h6>
                <div className="row">
                  <div className="col-6">
                    <ul>
                      <li>HANKAR-6</li>
                      <li>V-797 </li>
                      <li>MECH-1 </li>
                    </ul>
                  </div>
                  <div className="col-6">
                    <ul>
                      <li>MCU-5 </li>
                      <li>DCH-32 </li>
                      <li>Imported Cotton </li>
                    </ul>
                  </div>
                </div>
              </div> */}
             
            </div>
            
          </div>
        </div>
      </section>
    </>
  )
}

export default Companyprofile
